import { webClient } from "@shared/apis"
import { Pagination } from "@shared/types"

const statisticApi = {
  lastDayViewers: (
    startDate: string,
    endDate: string,
    page: number,
    size: number,
  ) =>
    webClient.get<Pagination<LastDayStatistic>>("/statistics/days/all", {
      params: { startDate, endDate, page, size },
    }),
  todayViewers: (
    startDate: string,
    endDate: string,
    page: number,
    size: number,
  ) =>
    webClient.get<Pagination<TodayStatistic>>(
      "/statistics/cumulative/viewers",
      {
        params: { startDate, endDate, page, size },
      },
    ),
}

export default statisticApi

interface LastDayStatistic {
  id: number
  freePcNonmemberCount: number
  freeMobileNonmemberCount: number
  freeMobileAppNonmemberCount: number
  memberCount: number
}

export interface TodayStatistic {
  userCount: number
}
